const files = require.context('../../jsx/pages', true, /\.enum\.js$/i);
const fileskeys = files.keys();
export const entries = {
    ...fileskeys.map(key=>files(key).default).reduce((o,n)=>({...o,...n}),{})
}
export default entries;